import React from 'react';
import { SvgIcon } from '@mui/material';

export function FillVkIcon(props) {
  return (
    <SvgIcon viewBox="0 0 42 42" {...props}>
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="42" height="42" rx="16" fill="#FFBC5B" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7305 27.9265H22.1647C22.1647 27.9265 22.598 27.8806 22.8221 27.6361C23.0313 27.4069 23.0163 26.9942 23.0163 26.9942C23.0163 26.9942 22.9865 25.0228 23.8829 24.7324C24.7643 24.442 25.8998 26.6427 27.095 27.4833C28.0064 28.1252 28.6936 27.9876 28.6936 27.9876L31.9058 27.9418C31.9058 27.9418 33.5791 27.8348 32.7872 26.4899C32.7275 26.3829 32.3241 25.4965 30.3968 23.6626C28.3799 21.7523 28.6488 22.0579 31.0841 18.7568C32.5631 16.7395 33.1458 15.5169 32.9665 14.982C32.7872 14.4777 31.7115 14.6152 31.7115 14.6152L28.096 14.6458C28.096 14.6458 27.8271 14.6152 27.6329 14.7375C27.4386 14.8597 27.3191 15.1348 27.3191 15.1348C27.3191 15.1348 26.7514 16.6937 25.9894 18.0233C24.3759 20.82 23.7335 20.9728 23.4795 20.7894C22.8669 20.3921 23.0163 19.1695 23.0163 18.2983C23.0163 15.5933 23.4197 14.4624 22.2394 14.172C21.851 14.0803 21.5522 14.0039 20.5512 14.0039C19.2663 13.9886 18.1757 14.0039 17.5482 14.3248C17.1299 14.5235 16.8162 14.9973 17.0104 15.0125C17.2494 15.0431 17.7873 15.1654 18.0711 15.5627C18.4446 16.0823 18.4297 17.2286 18.4297 17.2286C18.4297 17.2286 18.6389 20.4227 17.9367 20.82C17.4436 21.0951 16.7863 20.5296 15.352 17.9927C14.6199 16.6937 14.0672 15.2571 14.0672 15.2571C14.0672 15.2571 13.9626 14.982 13.7684 14.8444C13.5442 14.6763 13.2156 14.6152 13.2156 14.6152L9.77932 14.6305C9.77932 14.6305 9.25641 14.6458 9.07713 14.875C8.91278 15.0737 9.06219 15.5016 9.06219 15.5016C9.06219 15.5016 11.7514 21.9356 14.7992 25.1756C17.5632 28.1252 20.7305 27.9265 20.7305 27.9265Z"
          fill="#4520AB"
        />
      </svg>
    </SvgIcon>
  );
}
